<div style="width: auto; overflow: auto">
    <app-common-list-table
        [showExportCsv]="false"
        [request]="getRequest"
        [cols]="cols"
        [globalConditionalStyle]="globalConditionalStyle"
        [globalVisualTransform]="globalVisualTransform"
        [actionButtonText]="env.canAdd ? btnAnadir : ''"
        (actionButtonClick)="add()"
        (edit)="edit($event)"
        (duplicate)="duplicate($event)"
        (remove)="show('delete', $event)"
        (visualize)="show('info', $event)">

        <ng-template #thEnd>
            <th class="rt-col-actions" style="width: 120px;">
                <p class="d-flex justify-content-center mb-0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data>
            <td class="rt-col-actions">
                <div class="w-full d-flex justify-content-center align-items-center gap-4">
                    <app-action-buttons
                        [hideDelete]="false"
                        [showDuplicate]="env.canDuplicate"
                        (duplicateRowButtonEvent)="duplicate(data.data)"
                        (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)"
                        (showRowButtonEvent)="show('info', data.data)">
                    </app-action-buttons>
                </div>
            </td>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="env.serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>